import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { LocationContext } from "../../../CustomHelper/Helper";
import Navigation from "../../Layouts/Header/Navigation";

import PaymentModal from "../PaymentModal/PaymentModal";
import "./CategoryModal.css";

const CategoryModal = (props) => {
  const [modalShowPay, setModalShowPay] = React.useState(false);
  const [allPackages, setAllPackage] = useState([]);
  const [userId, setUserId] = useState("");
  const [packageId, setPackageId] = useState("");

  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  useEffect(() => {
    axios.get(`/api/user/packages/all`).then((res) => {
      if (res.status === 200) {
        setAllPackage(res.data.allPackages);
        setUserId(res.data.userId);
      }
    });
  }, []);

  const handleModel = (data) => {
    setPackageId(data);
    // props.setModalShow(false);
    setModalShowPay(true);
  };

  const handleModelFree = (data) => {
    setModalShowPay(false);
    setPackageId(data);

    axios.post(`/api/user/free/wallet/store/${data}/${userId}`).then((res) => {
      if (res.data.status === 200) {
        swal("Welcome", res.data.message, "success");
      }
    });
  };

  const history = useHistory();

  return (
    <>
      {" "}
      <Navigation />
      <div className="Package-container mx-auto ">
        <div className="container  mx-auto ">
          <div className="row mx-auto  ">
            <div className="pak-header text-center col-md-12">
              <p text-center>Select the perfect package for you</p>
            </div>

            {allPackages.map((data) => (
              <div className="col-md-3 col-sm-12 package-bg my-5 ">
                <div className="pak-b">
                  <div className="pa-header">
                    <p> {data?.title}</p>
                  </div>
                  <div className="package">
                    <p>
                      {" "}
                      {data.club_points === 0 ? (
                        <i className="fa-solid fa-xmark packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      ) : (
                        <i className="fa-solid fa-check packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      )}{" "}
                      Club Points : {data.club_points}
                    </p>
                    <p>
                      {data.auditions === 0 ? (
                        <i className="fa-solid fa-xmark packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      ) : (
                        <i className="fa-solid fa-check packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      )}{" "}
                      Auditions : {data.auditions}
                    </p>
                    <p>
                      {data.learning_session === 0 ? (
                        <i className="fa-solid fa-xmark packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      ) : (
                        <i className="fa-solid fa-check packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      )}{" "}
                      Learning Session : {data.learning_session}
                    </p>
                    <p>
                      {data.live_chats === 0 ? (
                        <i className="fa-solid fa-xmark packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      ) : (
                        <i className="fa-solid fa-check packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      )}{" "}
                      Live Chats : {data.live_chats}
                    </p>
                    <p>
                      {data.meetup === 0 ? (
                        <i className="fa-solid fa-xmark packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      ) : (
                        <i className="fa-solid fa-check packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      )}{" "}
                      Meetup Events : {data.meetup}
                    </p>
                    <p>
                      {data.greetings === 0 ? (
                        <i className="fa-solid fa-xmark packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      ) : (
                        <i className="fa-solid fa-check packageColor">
                          {" "}
                          &nbsp;
                        </i>
                      )}{" "}
                      Greetings : {data.greetings}
                    </p>
                  </div>
                  <div className="but-c">
                    <p>
                      <b className="dollar">
                        {paymentCountWithSymbol(data.price)}
                      </b>{" "}
                    </p>
                    {/* <button
                        className="package-btn"
                        type="button"
                        data-bs-toggle="collapse" onClick={handleClick}
                        data-bs-target="#panelsStayOpen-collapseThree"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseThree"
                      >
                        Buy Now
                      </button> */}

                    {/* <button className="package-btn" type="button" onClick={() => handleModel(data.id)}>Buy Now
                    </button> */}

                    {data.price === 0 ? (
                      <button
                        className="package-btn"
                        type="button"
                        onClick={() => handleModelFree(data.id)}
                      >
                        Free
                      </button>
                    ) : (
                      <button
                        className="package-btn"
                        type="button"
                        onClick={() => handleModel(data.id)}
                      >
                        Buy Now
                      </button>
                    )}

                    <PaymentModal
                      show={modalShowPay}
                      onHide={() => setModalShowPay(false)}
                      packageId={packageId}
                      userId={userId}
                      type="package"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <PaymentModal show={modalShowPay} onHide={() => setModalShowPay(false)} /> */}
    </>
  );
};

export default CategoryModal;
